var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9782 8.97756H10.9778V6.97722C10.9778 6.71196 10.8725 6.45756 10.6849 6.26999C10.4973 6.08243 10.2429 5.97705 9.97767 5.97705C9.71241 5.97705 9.45801 6.08243 9.27044 6.26999C9.08287 6.45756 8.9775 6.71196 8.9775 6.97722V8.97756H6.97716C6.7119 8.97756 6.4575 9.08293 6.26993 9.2705C6.08236 9.45807 5.97699 9.71247 5.97699 9.97773C5.97699 10.243 6.08236 10.4974 6.26993 10.685C6.4575 10.8725 6.7119 10.9779 6.97716 10.9779H8.9775V12.9782C8.9775 13.2435 9.08287 13.4979 9.27044 13.6855C9.45801 13.873 9.71241 13.9784 9.97767 13.9784C10.2429 13.9784 10.4973 13.873 10.6849 13.6855C10.8725 13.4979 10.9778 13.2435 10.9778 12.9782V10.9779H12.9782C13.2434 10.9779 13.4978 10.8725 13.6854 10.685C13.873 10.4974 13.9783 10.243 13.9783 9.97773C13.9783 9.71247 13.873 9.45807 13.6854 9.2705C13.4978 9.08293 13.2434 8.97756 12.9782 8.97756Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM10 2.06934C5.61981 2.06934 2.06934 5.61981 2.06934 10C2.06935 14.3802 5.61982 17.9307 10 17.9307C14.3802 17.9307 17.9307 14.3802 17.9307 10C17.9307 5.61981 14.3802 2.06934 10 2.06934Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.12c3ecfe0bc4381888d1ef72b1617f3f.svg";
export { ForwardRef as ReactComponent };